module.exports = __webpack_public_path__ + "static/img/mainbg-N022.1acc5b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/main/mainbg-N022.png
// module id = bn2R
// module chunks = 1